import type {
  ContestViewEntriesCollection,
  ContestViewEntry,
  User,
} from '@freelancer/datastore/collections';
import type { BackendErrorResponse } from '@freelancer/freelancer-http';

export enum ContestAwardModalResponseType {
  AWARD,
  AWARD_MULTIPLE,
  ERROR,
}

export interface ContestAwardModalErrorResponse {
  type: ContestAwardModalResponseType.ERROR;
  error: BackendErrorResponse<
    ContestViewEntriesCollection['Backend']['Update']['ErrorType'] | 'FORBIDDEN'
  >;
}

export interface ContestAwardModalMultipleAwardResponse {
  type: ContestAwardModalResponseType.AWARD_MULTIPLE;
}

export type ContestAwardModalResponse =
  | ContestAwardModalErrorResponse
  | ContestAwardModalMultipleAwardResponse
  | undefined;

export interface ContestAwardModalDetails {
  readonly entry: ContestViewEntry;
  readonly freelancer: User;
  readonly canMultiAward: boolean;
  readonly isContestOwner: boolean;
}
